export default "/assets/images/app-update-img-02.webp?7a7ccf6994c0b346dd1de0fb3bbc1831";